import * as wjcSheet from '@grapecity/wijmo.grid.sheet';

import { SagdSource } from '../../../_models/_unit-operations/sagd-source';
import { enumValuesToArray } from '../../../_utils/enum-values-to-array';
import { SagdSourceFlexSheetMapper } from '../mappers/sagd-source-flex-sheet-mapper';
import { NumberToSimulationVariableMapper } from '../mappers/number-to-simulation-variable-mapper';
import { SagdSourceSheetRows, SagdSourceCellConfig } from '../cell-config/sagd-source-cell-config';
import { FlexSheetValueConverter } from '../flex-sheet-value-converter';
import { UnitOperationFlexSheetEventHandler } from './unit-operation-flex-sheet-event-handler';

export class SagdSourceFlexSheetEventHandler implements UnitOperationFlexSheetEventHandler {
  constructor(private valueConverter: FlexSheetValueConverter) {}

  handle(unitOperation: SagdSource, spreadsheet: wjcSheet.FlexSheet, flexSheetEvent, rawValue) {
    const { row } = flexSheetEvent;

    if (enumValuesToArray(SagdSourceSheetRows).indexOf(row) === -1) {
      flexSheetEvent.cancel = true;
      return;
    }

    const cellConfig = SagdSourceCellConfig.find(rowConfig => rowConfig.row === row);
    const convertedValue = this.valueConverter.convert(spreadsheet, rawValue, cellConfig);

    const simulationVariableMapper = new NumberToSimulationVariableMapper();
    const mapper = new SagdSourceFlexSheetMapper(simulationVariableMapper);

    mapper.map(unitOperation, row, convertedValue);
  }
}
